const VOTE_LABELS = {
  weak: "\u0636\u0639\u06cc\u0641",
  medium: "\u0645\u062a\u0648\u0633\u0637",
  good: "\u062e\u0648\u0628",
};

export default VOTE_LABELS;
export { VOTE_LABELS };
